import { ProfileElement, ProfileElementCreator } from './Profile-model'

export class DoorStepElement extends ProfileElement {
  constructor(doorstep: DoorStepElementCreator) {
    super(doorstep)
  }
}

export interface DoorStepElementCreator extends ProfileElementCreator {}
